export const TAGZ_FEATURE_CODE = 'tagz';
export const TAGZ_CONTEXT_NAME = 'tagz';
export const TAGZ_NUMBER_TAGZ_PER_CARD = 10;
export const TAGZ_NUMBER_TAGZ_FOR_SECTION = 30;
export const TAGZ_NUMBER_TAGZ_FOR_ALL_TAGS_SECTION = 50;
export const TAGZ_NUMBER_TAGZ_FOR_RELATED_TAGS = 5;
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';
export const SKELETON_TEXT_WIDTH = '60px';
export const TAG_RECENT_SORT = 'CREATION_DATE';
export const TAGZ_MAX_LENGTH = 50;
export const TAGZ_FORBIDDEN_CHARACTERS = '#＃';
export const TAGZ_NB_MAX_SUGGESTIONS = 3;
